<template>
  <div class="cast-launcher">
    <div v-if="isCastError">
      <h3 class="error-message">{{ web3Error }}</h3>
    </div>
    <div v-if="isCasted" class="is-casted">
      <h3>Transaction created:</h3>
      <h5>{{ web3Transaction }}</h5>
      <button class="btn btn-secondary" @click="checkCast">checkCast</button>
      <div v-if="checkCastResult">
        <table class="table"><tbody><tr><th>key</th><th>value</th></tr>
          <tr><td>cast_creator</td><td>{{ checkCastResult._cast_creator }}</td></tr>
          <tr><td>cast_owner</td><td>{{ checkCastResult._cast_owner }}</td></tr>
          <tr><td>description</td><td>{{ checkCastResult._description}}</td></tr>
        </tbody></table>
      </div>
    </div>
    <!--PREPARED-->
    <div v-if="isPrepared || isCastError || isCasted">
      <h3>Prepared contract args:</h3>
      <pre class="contract-args">{{ JSON.stringify(contractArgs, null, 2) }}</pre>
      <div class="row">
        <div class="col-lg-6">
          <button type="button" class="btn btn-light" :disabled="null == web3account" @click="castContract">
            <img v-if="web3jsInited" class="btn-img" src="../../assets/metamask.svg">
            <div v-if="web3jsInited">Cast with Metamask</div>
            <div><small>{{ web3network }}</small></div>
            <div v-show="null != web3account">
              <div><small>Selected account:</small></div>
              <div><small>
                <svg width="100%" height="100%" viewBox="0 -70 1000 70" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <text font-size="43" fill="black">{{ web3account }}</text>
                </svg></small></div>
            </div>
            <div v-show="null == web3account" class="error">
              <div><b>No account selected!</b></div>
              <div><small>Please login to MetaMask</small></div>
            </div>
            <h3 v-if="!web3jsInited">No Web3-JS<br>was found</h3>
          </button>
        </div>
        <div class="col-lg-6">
          <button disabled type="button" class="btn btn-light">
            <img class="btn-img" src="../../assets/qr-code.svg">
            <div>Get contract arguments<br>as QR-code</div>
            <div><small>(work in progress)</small></div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue               from 'vue'
  import { mapActions
         , mapGetters
         , mapState      } from 'vuex'

  export default {
    name: "CastLauncher"
  , data () {
      return {
        fileCount: 0
      , description: null
      , error: null
      }
    }
  , components: {}
  , computed: {
      ...mapGetters(['isPrepared'])
    , ...mapGetters(['isCasted', 'isCastError'])
    , ...mapState(['uploadedFiles', 'contractArgs'])
    , ...mapState(['web3jsInited', 'web3network', 'web3account', 'web3Error', 'web3Transaction', 'gasPrice'])
    , ...mapState(['checkCastResult'])
    , fileName() { return this.uploadedFiles[0] ? this.uploadedFiles[0].originalName : null }
    }
  , methods: {
      ...mapActions(['initWeb3JS', 'getAccount', 'castWeb3Contract', 'resetCast', 'getGasPrice'])
    , ...mapActions(['checkCastReset', 'checkCast'])
    , castContract() {
        this.resetCast().then( () =>
          this.castWeb3Contract().then( result => {
            // console.log('castWeb3Contract result:', result)
            this.checkCastReset().then(() =>
              this.$router.push({ name: 'Result' })
            )
          })
        )
      }
    }
  , mounted() {
      if (0 == this.uploadedFiles.length) {
        this.$router.push({ name: 'Dropzone' })
      }
      const self = this;
      this.initWeb3JS().then(result => {
         // console.log('initWeb3JS result:', result)
         return result
           ? self.getAccount().then(() => self.getGasPrice())
           : (this.error = "Web3 is unavailable", this.error)
      })
    }
  }
</script>

<style lang="scss" scoped>
  .cast-launcher {
    width: 60%;
    margin-left: 20%;
    margin-right: 20%;
    h3 {
      text-align: left;
    }
    .contract-args {
      text-align: left;
    }
    button {
      width: 100%;
      min-height: 126px;
      margin-top: 10pt;
      margin-bottom: 10pt;
      border-color: #757575;
      border-radius: 6pt;
      .btn-img {
        //width: 4em;
        height: 4em;
      }
      h3 {
        text-align: center;
      }
    }
    .error-message {
      border-radius: .25em;
      background-color: #ff4444;
    }
    .is-casted {
      min-height: 10em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/caster/CastLauncher.vue